import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconApps } from "@arco-design/web-vue/es/icon"

const routes: AppRouteRecordRaw = {
  path: '/marketplace',
  redirect: '/marketplace/emplate-market',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '市场',
    icon: IconApps,
    // hideInMenu: true,
    // hideChildrenInMenu: true,
    order: 700,
    roles: ['authorized-org-admin', 'admin'],
    // roles: ['system-admin', 'admin'],

  },
  children: [
    {
      path: 'emplate-market',
      component: () => import('@/views/marketplace/emplate-market.vue'),
      meta: {
        title: '权重模板市场',
      },
    },
    {
      path: 'publishing-template/:id?',
      props: true,
      component: () => import('@/views/marketplace/components/emplate-market/publishing-template.vue'),
      meta: {
        title: '发布模板',
        hideInMenu: true,
        activeMenu: '/marketplace/emplate-market',
      },
    },
    {
      path: 'publishing-template-details/:id?',
      props: true,
      component: () => import('@/views/marketplace/components/emplate-market/publishing-template-details.vue'),
      meta: {
        title: '模板详情',
        hideInMenu: true,
        activeMenu: '/marketplace/emplate-market',
      },
    },
    // {
    //   path: 'add-edit-weight',
    //   component: () => import('@/views/marketplace/components/weight/add-edit-weight.vue'),
    //   meta: {
    //     title: '新增权重',
    //     hideInMenu: true,
    //     ignoreCache: true,
    //     noAffix: true,
    //     activeMenu: '/marketplace/weight-template',
    //   },
    // },
    // {
    //   path: 'add-edit-weight/:id?/:type?',
    //   component: () => import('@/views/marketplace/components/weight/add-edit-weight.vue'),
    //   props: true,
    //   meta: {
    //     title: '编辑权重',
    //     hideInMenu: true,
    //     ignoreCache: true,
    //     noAffix: true,
    //     activeMenu: '/marketplace/weight-template',
    //   },
    // },
    {
      path: 'engine-market',
      component: () => import('@/views/marketplace/engine-market.vue'),
      meta: {
        title: '引擎市场',
      },
    },

  ],
};

export default routes;
